// extracted by mini-css-extract-plugin
export var content = "_oc-1";
export var fullScreen = "_oc-0";